"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isLocalStorageAvailable() {
  try {
    return typeof localStorage !== 'undefined' && 'setItem' in localStorage && typeof localStorage.setItem === 'function';
  } catch (e) {
    return false;
  }
}
/**
 * Returns a new `StorageEngine` which saves data to the browser's LocalStorage.
 *
 * Throws if `localStorage` is not present on the `window` object.
 */


exports.default = function (key, replacer, reviver) {
  if (!isLocalStorageAvailable()) {
    throw new Error('Missing LocalStorage in window context');
  }

  return {
    load: function load() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var jsonState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                jsonState = localStorage.getItem(key);
                return _context.abrupt("return", JSON.parse(jsonState, reviver) || {});

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    save: function save(state) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var jsonState;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jsonState = JSON.stringify(state, replacer);
                localStorage.setItem(key, jsonState);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  };
};